import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Table } from 'react-bootstrap';

import SideMenu from "../../../../Components/SideDrawer";
import PageHeader from "../../../../Components/Header";
import { teamGet, teamMemberDeails } from "../../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../../Utils/ErrorUtlis";

const TeamMemberDetails = () => {
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [team, setTeam] = useState([]);
  const [loadingTeam, setLoadingTeam] = useState(false)
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    team_name: ''
  });

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const data = await teamGet();
        if (data) {
          const teamData = data.results.map(i => ({
            id: i.team_id,
            team_name: i.team_name,
            description: i.description,
            companyId: i.company_id,
          }));
          setTeam(teamData)
          setLoadingTeam(true);
          console.log(teamData);
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Team Deails: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchTeam();
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    const fetchData = async () => {
      console.log('Log2');
      try {
        const data = await teamMemberDeails();
        console.log("Team Data", data.results);

        if (data.results) {
          const teamMembers = data.results.map(i => ({
            emp_id: i.emp_id,
            name: i.name,
            design:i.Design,
            company: i.company,
            Team: i.Team
          }));
          const filterTeam = formData.team_name ? teamMembers.filter(tam => tam.Team === formData.team_name) : null
          setSelectedTeam(filterTeam)
          if (selectedTeam) {
            setIsLoading(false);
          }
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Team Member Deails: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchData();
    console.log('Log1');
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
  return (
    <div className="d-flex">
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Team Member Details' showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Member Details
        </h4>
        <Form onSubmit={handleSubmit} className="m-4 align-items-center">
          <Row className="mb-3">
            <Form.Group as={Col} md='4' controlId="team_name">
              <Form.Label>Team Name</Form.Label>
              <Form.Select
                name="team_name"
                value={formData.team_name}
                onChange={handleChange}
                required
              >
                <option>Select The Team</option>
                {!loadingTeam ? (<div>Loading...</div>) : (team.map(tm => (
                  <option key={tm.id} value={tm.team_name}>{tm.team_name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' className="text-center">
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px', height: '30px' }}>
                Get Team
              </Button>
            </Form.Group>
          </Row>
        </Form>
        <h5 className="mb-4 d-flex justify-content-between align-items-center">
          Team Name: {formData.team_name}
        </h5>
        {isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div style={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Emp Id</th>
                <th className="fs-12">Name</th>
                <th className="fs-12">Designation</th>
                <th className="fs-12">Company Name </th>
              </tr>
            </thead>
            <tbody>
              {selectedTeam.map((team, i) => (
                <tr key={team.emp_id}>
                  <td className="fs-12">
                    {team.emp_id}
                  </td>
                  <td className="fs-12">
                    {team.name}
                  </td>
                  <td className="fs-12">
                    {team.design}
                  </td>
                  <td className="fs-12">
                    {team.company}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
      </Container>
    </div>
  );
};

export default TeamMemberDetails;